import React from 'react';
import ContentEditable from 'react-contenteditable'
import { weiToMeow } from '../util/Utils'
import yinYangCat from '../img/yinyang10.png';
import NumberFormat from 'react-number-format'

class Swap extends React.Component {
  constructor(props) {
    super(props);
    this.ceRef = React.createRef();

    const grumpyBalance = props.grumpy.tokenBalance;

    const tokenEthVal = grumpyBalance && window.web3.utils.fromWei(grumpyBalance.toString(), 'gwei');

    this.state = {
      allowance: null,
      supply: null,
      tokenEthVal,
      grumpToSwap: '',
      meowReceived: '',
      meow: props.meow.contract,
      grumpy: props.grumpy.contract,
      account: props.accounts[0],
    }

    this.loadSupply();
    this.getAllowance();
  }

  componentDidMount = () => {
    this.ceRef.current.focus();
    if (this.state.tokenEthVal) {
      this.onChange({target: {value: this.state.tokenEthVal}});
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this.refresh);
  }

  loadSupply = async () => {
    const supply = await this.state.grumpy.methods.totalSupply().call({from: this.props.accounts[0]});
    this.setState({supply});
  }

  getAllowance = async () => {
    const allowance = await
      this.state.grumpy.methods.allowance(this.props.accounts[0], this.state.meow.address)
      .call({from: this.props.accounts[0]});

    console.log(allowance.toString());

    this.setState({allowance});

    this.refresh = setTimeout(this.getAllowance, 5000);
  }

  validGrumpyValue = (value) => {
    try {
      return window.web3.utils.toWei(value, 'gwei');
    }
    catch {
      return false;
    }
  };

  onChange = (e) => {
    const validInput = this.validGrumpyValue(e.target.value);
    const empty = e.target.value === '';

    if (validInput || empty) {
      const meow = empty ? '' : weiToMeow(validInput);
      this.setState({
        grumpToSwap: e.target.value,
        meowReceived: meow,
      });
    }
    else this.setState({
      grumpToSwap: this.state.grumpToSwap
    });
  };

  inputWeis = () => window.web3.utils.toWei(this.state.grumpToSwap, 'gwei')

  approveGrumpies = (e) => {
    if (this.state.grumpToSwap !== '') {
      this.state.grumpy.methods.approve(this.state.meow.address, this.state.supply)
        .send({ from: this.state.account })
    }
  }

  swapGrumpies = (e) => {
    if (this.state.grumpToSwap !== '') {
      this.state.meow.methods.swapGrumpy(this.inputWeis()).send({ from: this.state.account });
    }
  }

  render = () => {
    const grumpyWeis = this.state.grumpToSwap && this.inputWeis();

    const sufficientAllowance = grumpyWeis && this.state.supply
      && this.state.allowance && this.state.allowance.gte(grumpyWeis);
    
    return (
      <div className='centered'>
        <img src={yinYangCat} className='logoImg rotate' alt='Yin Yang Cats'/>
        <div className='cleanInputContainer leftAligned'>
          <div className='centered-text extra-margin'>
            <small>10,000 Grumpy = 1 Meow</small>
          </div>
          <strong className='right-fixed'>$GRUMPY</strong>{' '}
          <ContentEditable
            className='cleanInput'
            innerRef={this.ceRef}
            html={this.state.grumpToSwap}
            disabled={false}
            onChange={this.onChange}
          />
        </div>
        {!this.state.allowance || !grumpyWeis || grumpyWeis === '0' ?
          <div className='basic-button disabled'>~~~~~</div> :
          sufficientAllowance ?
            <div className='basic-button' onClick={this.swapGrumpies}>{'->'}</div> :
            <div className='basic-button' onClick={this.approveGrumpies}>Approve</div>
        }
        <div className='leftAligned'>
          <strong className='right-fixed'>$MEOW</strong>{' '}
          <NumberFormat value={this.state.meowReceived} displayType={'text'} thousandSeparator={true} /> 
        </div>
      </div>
    );
  }
}

export default Swap;
